import type { ComentarioPesquisa, ItemPesquisa } from "../../../services/pesquisaSatisfacao"

export type PesquisaSatisfacaoFornecedorModel = {
    inicioMs: number
    fimMs: number
    itens: ItemPesquisa[]
    comentarios: ComentarioPesquisa[]
    total: number
}

function inicioDoAnoMs(): number {
    const d = new Date()
    return new Date(d.getFullYear(), 0, 1).getTime()
}

export const PesquisaSatisfacaoFornecedorInicial: PesquisaSatisfacaoFornecedorModel = {
    inicioMs: inicioDoAnoMs(),
    fimMs: Date.now(),
    itens: [],
    comentarios: [],
    total: 0,
}
